import { MenuConfigItem } from 'src/app/shared/interfaces/interface';

export const MenuConfig: { [key: string]: MenuConfigItem } = {
  Home: {
    iconName: 'dashboard',
    route: '/home',
    subMenus: {},
  },
  Features: {
    iconName: 'feature',
    subMenus: {
      'Convective Alerting Tool (CAT)': { route: '/cat' },
      'Fire & Steam Risk': { route: '/fsr' },
    },
  },
  Admin: {
    iconName: 'admin',
    subMenus: {
      Configuration: { route: '/admin' },
    },
  },
  // Add other menu items similarly...
};
